import { clsObj } from "client-util/util";
import "./Spooflantu.css";

export function SpooflantuBox(props: { parts: string[]; sol?: boolean }) {
  return (
    <>
      <span
        className={clsObj({
          "spooflantu-box": true,
          "no-copy": true,
          sol: props.sol ?? false,
        })}
      >
        {props.parts.map((part, i) => (
          <span
            key={i}
            style={{ fontSize: props.parts.length === 1 ? "200%" : undefined }}
          >
            {part}
          </span>
        ))}
      </span>
      <span className="copy-only">{props.parts.join(" / ") || "?"}</span>
    </>
  );
}
